import LoanService from "@/services/bytepro/loan.service";

export const loanApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    get({ commit }, loanId) {
      return LoanService.get(loanId).then(
        (resp) => {
          commit("dummy", "LoanService.get - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "LoanService.get - error");
          return Promise.reject(error.response);
        }
      );
    },
    update({ commit }, { loan, fileDataId }) {
      return LoanService.update(loan, fileDataId).then(
        (resp) => {
          commit("dummy", "LoanService.update - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "LoanService.update - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
